import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BlogHeader from '../components/blogHeader'


export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <Layout>
      <SEO title={post.frontmatter.title}/>
      <div>
        <BlogHeader 
          HeaderTitle={post.frontmatter.title}
          HeaderDesc={`Posted on ${post.frontmatter.date}`}
        />
        <div className="py-12 blog-container blogPost-container">
          <img src={post.frontmatter.featured.childImageSharp.fluid.src} className="pb-6" alt="" />
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date
        featured {
            childImageSharp {
              fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`